/* spin-wheel.js — Roue Golden High (front). Vanilla JS, zéro dépendance.
 *
 * Sécurité : le FRONT NE DÉCIDE JAMAIS du lot. Il POST {email,consent,locale} au Worker,
 * le Worker renvoie le segmentId tiré côté serveur, et le front se contente d'ANIMER la roue
 * pour s'arrêter sur la slice correspondante. Les leurres (15G/10G/5G/1KG) sont des slices
 * VISUELLES ; l'aiguille s'arrête toujours sur un des 3 segments réels (vip/shipping/ten).
 *
 * Config injectée via data-attributes du conteneur (#gh-spin-wheel) → rempli par la section Liquid.
 */
(function () {
  'use strict';

  const root = document.getElementById('gh-spin-wheel');
  if (!root) return;

  const cfg = {
    endpoint: root.dataset.endpoint,            // URL du Worker /spin
    locale: root.dataset.locale || 'fr',
    delayMs: parseInt(root.dataset.delay || '10000', 10),
    frequencyDays: parseInt(root.dataset.frequencyDays || '1', 10),
    storageKey: 'gh_spin_state',
  };

  // 8 slices VISUELLES dans l'ordre horaire (index 0 = secteur à 3h = sous le pointeur au repos).
  // segment = à quel résultat logique chaque slice correspond. Les leurres ont reward:false.
  // L'ordre exact + labels seront calés sur le Figma final d'Antoninho ; structure prête.
  const SLICES = JSON.parse(root.dataset.slices || '[]');
  // ex: [{label:"10€ OFFERT", segment:"ten"}, {label:"TU GAGNES 10G", segment:"g10", decoy:true}, ...]

  const SEGMENT_LABELS = JSON.parse(root.dataset.segmentLabels || '{}'); // {vip:"...",shipping:"...",ten:"..."}

  // ── Génère la roue SVG (8 slices) — en JS car Liquid ne fait pas de trigo ──
  function buildWheelSVG(container) {
    const n = SLICES.length || 8;
    const seg = 360 / n, R = 196, CX = 200, CY = 200;
    const rad = (d) => (d * Math.PI) / 180;
    const pt = (deg, r) => [CX + r * Math.cos(rad(deg)), CY + r * Math.sin(rad(deg))];
    let paths = '';
    SLICES.forEach((s, i) => {
      const a0 = i * seg, a1 = (i + 1) * seg;
      const [x0, y0] = pt(a0, R), [x1, y1] = pt(a1, R);
      const fill = i % 2 === 0 ? '#f53d00' : '#141414';
      paths += `<path d="M${CX},${CY} L${x0.toFixed(2)},${y0.toFixed(2)} A${R},${R} 0 0 1 ${x1.toFixed(2)},${y1.toFixed(2)} Z" fill="${fill}" stroke="#0a0a0a" stroke-width="1"/>`;
      const mid = a0 + seg / 2;
      const [lx, ly] = pt(mid, R * 0.62);
      paths += `<text x="${lx.toFixed(2)}" y="${ly.toFixed(2)}" transform="rotate(${mid.toFixed(2)} ${lx.toFixed(2)} ${ly.toFixed(2)})" text-anchor="middle" dominant-baseline="middle" fill="#fff" font-size="12" font-weight="700" font-family="Inter,sans-serif">${escapeXml(s.label)}</text>`;
    });
    container.innerHTML =
      `<svg class="sw-wheel" data-sw-wheel viewBox="0 0 400 400" role="img" aria-label="Roue Golden High">${paths}</svg>`;
    return container.querySelector('[data-sw-wheel]');
  }
  function escapeXml(s) { return String(s).replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c])); }

  const wheelHost = root.querySelector('[data-sw-wheel-host]');
  const builtWheel = wheelHost ? buildWheelSVG(wheelHost) : null;

  const els = {
    overlay: root.querySelector('[data-sw-overlay]'),
    tab: root.querySelector('[data-sw-tab]'),
    modal: root.querySelector('[data-sw-modal]'),
    scrim: root.querySelector('[data-sw-scrim]'),
    wheel: builtWheel || root.querySelector('[data-sw-wheel]'),
    form: root.querySelector('[data-sw-form]'),
    email: root.querySelector('[data-sw-email]'),
    cta: root.querySelector('[data-sw-cta]'),
    error: root.querySelector('[data-sw-error]'),
    panels: root.querySelectorAll('[data-sw-panel]'),
    code: root.querySelectorAll('[data-sw-code]'),
    wonLabel: root.querySelectorAll('[data-sw-won-label]'), // 2 emplacements : écran avec code, écran sans code (VIP)
  };

  const showPanel = (name) => {
    els.panels.forEach((p) => { p.hidden = p.dataset.swPanel !== name; });
    root.dataset.state = name;
  };

  const setError = (msg) => { if (els.error) { els.error.textContent = msg || ''; els.error.hidden = !msg; } };

  // ── State local (1 jeu / fréquence, mémo du code gagné) ───────────────────
  function readState() {
    try { return JSON.parse(localStorage.getItem(cfg.storageKey)) || {}; } catch { return {}; }
  }
  function writeState(s) {
    try { localStorage.setItem(cfg.storageKey, JSON.stringify(s)); } catch {}
  }

  // ── Onglet latéral (teaser) : visible quand le popup est fermé ─────────────
  // 2026-10-28 (lot 1, B1) : sur téléphone l'onglet se place sous l'en-tête (CSS --sw-tab-haut).
  // On mesure le bas de l'en-tête (barres du haut comprises) ; on garde la plus grande valeur vue,
  // celle du haut de page, pour que l'onglet ne recouvre jamais l'icône panier.
  let tabHaut = 0;
  function placeTab() {
    try {
      const hdr = document.querySelector('.header-section') || document.querySelector('.header');
      if (!hdr || !els.tab) return;
      const bas = Math.ceil(hdr.getBoundingClientRect().bottom) + 16;
      if (bas > tabHaut && bas < window.innerHeight) {
        tabHaut = bas;
        els.tab.style.setProperty('--sw-tab-haut', bas + 'px');
      }
    } catch (e) { /* valeur CSS par défaut */ }
  }
  window.addEventListener('resize', placeTab, { passive: true });
  setTimeout(placeTab, 2500); // la barre « code actif » arrive après le chargement du panier

  function showTab() {
    if (!els.tab) return;
    placeTab();
    const s = readState();
    // masqué si l'utilisateur a fermé l'onglet récemment (croix de l'onglet)
    if (s.tabClosedAt && Date.now() - s.tabClosedAt < cfg.frequencyDays * 86400000) return;
    els.tab.hidden = false;
  }
  function hideTab() { if (els.tab) els.tab.hidden = true; }
  function dismissTab() {
    hideTab();
    const s = readState(); s.tabClosedAt = Date.now(); writeState(s);
  }

  // ── Ouverture : délai, sauf si déjà vu récemment. L'onglet reste dispo ────
  function maybeOpen() {
    showTab(); // l'onglet est toujours proposé (sauf s'il a été fermé)
    const s = readState();
    if (s.played) return; // déjà joué → pas de ré-ouverture auto, mais onglet visible pour revoir le code
    if (s.lastSeen && Date.now() - s.lastSeen < cfg.frequencyDays * 86400000) return;
    setTimeout(open, cfg.delayMs);
  }

  function open() {
    if (els.overlay) els.overlay.hidden = false;
    hideTab();
    document.body.style.overflow = 'hidden';
    const s = readState();
    s.lastSeen = Date.now();
    writeState(s);
    if (s.played && s.code) { fillWon(s); showPanel('already'); }
    else if (s.played) { fillWon(s); showPanel('won-nocode'); } // déjà joué, gain sans code (VIP)
    else showPanel('gate');
  }
  function close() {
    if (els.overlay) els.overlay.hidden = true;
    document.body.style.overflow = '';
    showTab(); // à la fermeture, l'onglet réapparaît
  }

  function fillWon(s) {
    els.code.forEach((c) => { c.textContent = s.code || ''; });
    // 2026-10-10 : on remplit les DEUX emplacements. Avant, seul le premier l'était : l'écran du lot
    // « club VIP » (le plus fréquent) s'affichait sans titre, dans toutes les langues.
    els.wonLabel.forEach((l) => { l.textContent = s.label || ''; });
  }

  // ── Rotation de la roue jusqu'au centre de la slice du segment renvoyé ─────
  function sliceIndexForSegment(segmentId) {
    // 1er index dont segment == segmentId ET non-leurre. Garde-fou : jamais un leurre.
    const idx = SLICES.findIndex((sl) => sl.segment === segmentId && !sl.decoy);
    return idx >= 0 ? idx : SLICES.findIndex((sl) => !sl.decoy); // fallback : 1ère slice réelle
  }

  function spinTo(segmentId) {
    const n = SLICES.length || 8;
    const seg = 360 / n;
    const target = sliceIndexForSegment(segmentId);
    // pointeur fixe à droite (0°). Slice i centrée à i*seg + seg/2. On veut amener ce centre sous 0°.
    const center = target * seg + seg / 2;
    const turns = 6; // tours complets pour l'effet
    const finalDeg = turns * 360 + (360 - center);
    els.wheel.style.transition = 'transform 5s cubic-bezier(0.16, 1, 0.3, 1)'; // ease-out prononcé
    els.wheel.style.transform = `rotate(${finalDeg}deg)`;
    return 5000;
  }

  // ── Soumission ────────────────────────────────────────────────────────────
  let submitting = false;
  async function submit(e) {
    e && e.preventDefault();
    if (submitting) return;
    setError('');
    const email = (els.email.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setError(root.dataset.msgEmail || 'Email invalide'); return; }

    submitting = true;
    els.cta.disabled = true;
    showPanel('spinning');

    let res;
    try {
      const r = await fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, consent: true, locale: cfg.locale }),
      });
      res = await r.json();
      if (!r.ok && res.error) throw new Error(res.error);
    } catch (err) {
      submitting = false; els.cta.disabled = false;
      showPanel('gate');
      setError(mapError(err && err.message));
      return;
    }

    // res = { status:'won'|'already_played', segmentId, label, code, expiresAt }
    const wait = spinTo(res.segmentId);
    setTimeout(() => {
      const s = readState();
      // Libellé du lot : d'abord celui de la page (traduit, clés gh.spin_wheel.won.*), sinon celui du Worker.
      // Avant le 2026-10-10 c'était l'inverse, et le Worker ne connaît que le français : un visiteur
      // italien lisait « HAI VINTO LIVRAISON OFFERTE ». Le lot, le code et l'envoi ne changent pas.
      s.played = true; s.code = res.code || ''; s.label = SEGMENT_LABELS[res.segmentId] || res.label || '';
      s.segmentId = res.segmentId; writeState(s);
      fillWon(s);
      // VIP (pas de code) → panneau gagné « soft » ; sinon panneau gagné avec code.
      showPanel(res.code ? 'won' : 'won-nocode');
      submitting = false;
    }, wait);
  }

  function mapError(code) {
    const m = {
      invalid_email: root.dataset.msgEmail,
      consent_required: root.dataset.msgConsent,
      rate_limited: root.dataset.msgRate,
    };
    return m[code] || root.dataset.msgNetwork || 'Une erreur est survenue, réessaie.';
  }

  // ── Copie du code ─────────────────────────────────────────────────────────
  root.addEventListener('click', (e) => {
    const copyBtn = e.target.closest('[data-sw-copy]');
    if (copyBtn) {
      const code = readState().code || '';
      if (code && navigator.clipboard) navigator.clipboard.writeText(code).then(() => {
        copyBtn.dataset.copied = '1';
        setTimeout(() => { delete copyBtn.dataset.copied; }, 2000);
      });
    }
    if (e.target.closest('[data-sw-tab-close]')) { e.stopPropagation(); dismissTab(); return; } // croix de l'onglet
    if (e.target.closest('[data-sw-tab]')) { open(); return; }                                   // clic sur l'onglet → rouvre
    if (e.target.closest('[data-sw-close]') || e.target === els.scrim) close();
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && els.overlay && !els.overlay.hidden) close(); });
  if (els.form) els.form.addEventListener('submit', submit);

  // Expose une ouverture manuelle (onglet latéral / debug).
  window.ghSpinWheelOpen = open;

  // Démarrage auto (sauf en mode harnais de test qui pilote manuellement).
  if (root.dataset.autostart !== 'false') maybeOpen();
})();
